import React, {useEffect, useState} from "react";
import {getAllBranchFxn, getSummaryFxn} from "../actions";
import {Card, DatePicker, InputBox, Table} from "../../../components/Elements/appUtils";
import moment from "moment";
import {fetchCustomer} from "../../branch/actions";

const {RangePicker} = DatePicker;

const ReportSummary = (props) => {
    let {user} = props;
    const [reportData, setReportData] = useState([]);
    const [fromDate, setFromDate] = useState(moment().startOf("day"));
    const [toDate, setToDate] = useState(moment().endOf("day"));
    const [refreshKey, setRefreshKey] = useState(moment());
    const [branchData, setBranchData] = useState([]);
    const [branchId, setBranchId] = useState("");

    const ranges = {
        Today: [moment().startOf("day"), moment().endOf("day")],
        "Last Week": [
            moment().subtract(1, "week").startOf("week"),
            moment().subtract(1, "week").endOf("week"),
        ],
        "Last 15 Days": [moment().subtract(14, "days"), moment().endOf("day")],
        "This Month": [moment().startOf("month"), moment().endOf("month")],
    };

    const getReportFxn = async () => {
        const params = {
            fromDate: moment(fromDate),
            toDate: moment(toDate),
        };
        if (branchId) {
            params.branchId = branchId;
        }
        const {data} = await getSummaryFxn(params);
        setReportData(data || []);
        setRefreshKey(moment())
    };

    // Initial load
    useEffect(() => {
        getReportFxn();
        if (["company", "headBranch"].includes(user.userType)) {
            loadBranch();
        }
    }, []);

    const loadBranch = async () => {
        const {data} = await getAllBranchFxn({});
        setBranchData(data);
    }

    // Reload on date change
    useEffect(() => {
        if (fromDate && toDate) {
            getReportFxn();
        }
    }, [fromDate, toDate]);

    useEffect(() => {
        getReportFxn();
    }, [branchId]);

    const columns = [
        {
            title: "Sr. No",
            dataIndex: "serialNo",
            key: "serialNo",
            width: "5%",
            render: (text, record, index) => index + 1,
        },
        {
            title: "Type",
            dataIndex: "type",
            key: "type",
            width: "20%",
        },
        {
            title: "Records",
            dataIndex: "count",
            key: "count",
            width: "20%",
            render: (item) => {
                return item ? item : 0
            }
        },
        {
            title: "GST Amount",
            dataIndex: "gstAmount",
            key: "gstAmount",
            width: "25%",
            render: (item) => {
                return item ? `Rs. ${item}` : 0
            }
        },
        {
            title: "Amount",
            dataIndex: "amount",
            key: "amount",
            width: "30%",
            render: (value, data) => {
                let {type, records} = data;
                return value ? <div>
                    <strong> {type == "Paid Report" ? `Total : Rs. ${value || 0}` : `Rs. ${value || 0}`}</strong>
                    {records && records.length ? <div className={'mt-4'}>
                        <ul className={'ul-sm'}>
                            {records.map((item) => {
                                return (
                                    item && item.amount ? <li key={item}>
                                        <span>{item.paymentType || "Unknown"} : </span>
                                        <strong>Rs. {item.amount}</strong>
                                    </li> : null
                                )
                            })}
                        </ul>
                    </div> : null}
                </div> : null
            }
        }
    ];

    return (
        <Card title="Sale Summary Report">
            <div className="row">
                <div className="col-md-4">
                    <InputBox title="Date">
                        <RangePicker
                            customStyle={{borderRadius: 50}}
                            value={[fromDate, toDate]}
                            onChange={(val) => {
                                if (!val) return;
                                setFromDate(val[0]);
                                setToDate(val[1]);
                            }}
                            ranges={ranges}
                        />
                    </InputBox>
                </div>
                {["company", "headBranch"].includes(user.userType) ? <div className="col-md-4">
                    <InputBox title="Head Branch / Branch">
                        <select
                            className="form-control search-filters"
                            placeholder="Search by Branch"
                            onChange={({target}) => {
                                setBranchId(target.value)
                            }}
                            style={{height: 38}}>
                            <option value="">Select Head Branch / Branch</option>
                            {branchData && branchData.length ? branchData.map((item) => {
                                return (
                                    <option key={item._id} value={item._id}>{item.name} -- ({item.userType})</option>
                                )
                            }) : null}
                        </select>
                    </InputBox>
                </div> : null}
            </div>

            <div className="row mt-4">
                <div className="col-md-12" key={refreshKey}>
                    <div className={'scrollable-table'}>
                        <Table
                            dataSource={reportData}
                            columns={columns}
                            rowKey="_id"
                        />
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default ReportSummary;
